import { sessaoFetchLoading } from '@/service/fetch'

export async function get (registro) {
  return sessaoFetchLoading(`consig`, `/entidades/buscarsiape/${registro}`)
}



// WEBPACK FOOTER //
// ./src/api/siape.js